import { TransactionSuccessToast } from "@/components";
import { type TransactionHash, TOKEN_IDS } from "@/types";
import { ToastDetailRow } from "@/components";

interface StakeSuccessToastProps {
    stakeAmount: number;
    transactionHash: TransactionHash;
    onClose?: () => void;
}

export function StakeSuccessToast({ stakeAmount, transactionHash, onClose }: StakeSuccessToastProps) {
    return (
        <TransactionSuccessToast title="Stake successful" transactionHash={transactionHash} onClose={onClose}>
            <ToastDetailRow label="Staked" amount={stakeAmount} tokenId={TOKEN_IDS.IUSD} />
            <ToastDetailRow label="Received" amount={stakeAmount} tokenId={TOKEN_IDS.SIUSD} />
        </TransactionSuccessToast>
    );
}
